import { createGate } from 'effector-react';

export const InvestProGate = createGate();
